const sessionStorageHelper = {
    getSessonStorage: (key) => {
        const obj  = JSON.parse(sessionStorage.getItem(key));

        return obj;
    },

    getSessonStorageData: (sessionStorageKey, jsonObjProp, location, history, callback) => {
        let timeOut = 120;

        const interval = setInterval(() => {
            timeOut--;
            const obj = sessionStorageHelper.getSessonStorage(sessionStorageKey);

            //Stop the interval if new route
            if (location.pathname !== history.location.pathname) {
                clearInterval(interval);
            }
            //Check for timeout
            if (timeOut === 0) {
                console.log('checkForServerResponse timeout');
                clearInterval(interval);

                callback('error');
            }
            //Check for error
            if (obj[jsonObjProp]) {
                if (obj[jsonObjProp] === 'error') {
                    callback('error');
                }
                clearInterval(interval);
                callback(obj[jsonObjProp])
            }

            console.log('Time: ', timeOut)
        }, 500)

       
    }
}

export default sessionStorageHelper